import * as React from "react";

import {
  Stack,
  Divider,
  Tooltip,
  Chip,
} from "@mui/material";

import RemoteHeadsetVideo from "../../../components/meeting/video/tiles/remote-headset-video/remote-headset-video";

import { WebLayout } from "../../../components/meeting/layouts";
import { useHeadsetConnected } from "../../../hooks/use-headset-connected";
import { MeetingToolbar, QRCodeToggleButton } from "../../../components/meeting/meeting-toolbar";

const TrainingLayout: React.FC = () => {
  const viewHeight = 92;
  const viewWidth = 100;

  // State to control the visibility of the QR code panel
  const [isQRCodeOpen, setIsQRCodeOpen] = React.useState(true);

  /**
   * Toggles the visibility of the QR code drawer panel
   */
  const toggleQRCode = () => {
    setIsQRCodeOpen(!isQRCodeOpen);
  };

  useHeadsetConnected(() => setIsQRCodeOpen(false));

  return (
    <Stack
      width={"100vw"}
      height={"100vh"}
      sx={{
        display: "flex",
        backgroundColor: "black",
      }}
    >

      <MeetingToolbar>
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          <QRCodeToggleButton
            isOpen={isQRCodeOpen}
            onToggle={toggleQRCode}
          />
          <Divider orientation="vertical" flexItem />
          <Tooltip title="Video from the RealWare is shown in place of Metro Video">
            <Chip label="Training Meeting" color="primary" sx={{ cursor: "default" }} />
          </Tooltip>
        </Stack>
      </MeetingToolbar>

      <WebLayout
        viewHeight={viewHeight}
        viewWidth={viewWidth}
        layout="training"
      />
      <RemoteHeadsetVideo />
    </Stack>
  );
};

export default TrainingLayout;
